import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, ProgressBar, Button, Tab, Tabs, Dropdown, Form, InputGroup } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faEllipsis, faLink, faCircleCheck, faChevronDown, faGear, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Slider from "react-slick";

import Docmnt from '../../../assets/images/google-docs.png';
import TruckWhite from '../../../assets/images/truck-white.png';
import Cargoplane from "../../../assets/images/plane.svg";
import Export from "../../../assets/images/export.svg";
import edit from "../../../assets/images/edit.png";
import Cargotruck from "../../../assets/images/cargo-truck.png";
import Cuser from "../../../assets/images/cuser.png";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import ImageUpload from '../../../Components/common/ImageUpload';
import ActivityComments from '../../../Components/common/ActivityComments';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { TRUCKAWBDETAILS, SLOTPLANNINGAVAILABLESLOT, SLOTPLANNINGAVAILABLESLOTCOUNT } from '../../../Utils/conts.js';
import Select from 'react-select';

const Awbs = ({ detailsClick }) => {

  const isMounted = useRef(false);
  const user = localStorage.getItem('RFS');
  const [isLoading, setIsLoading] = useState(true);
  const [disLoading, setDisLoading] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [gridData, setGridData] = useState([]);

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [gridSelect, setGridSelect] = useState([]);
  const gridRef = useRef(null);
  useEffect(() => {
    if (isMounted.current) return;
    // Call the fetchData function to fetch data from the API
    // fetchDataGrid();
    setIsLoading(false);
    setGridData([]);
    fetchDestination();
    isMounted.current = true;
  }, []);

  useEffect(() => {

    if (gridRef.current) {
      // if (gridData) {
      // const localData = gridData[activeTab].map(item => ({

      //     id: item.id,
      //     STN: item.station_code,
      //     Taddrs: item.station_addresses.length,
      //     Address: item.station_addresses // ?.join(', ')Join the address array into a string
      // }));
      var token = "Bearer " + (localStorage.RFS || localStorage.Trucking || '');
      const source = {
        url: `${process.env.REACT_APP_RFS_URL}monitor/awb-view-list`,
        beforeSend: function (jqXHR) {
          jqXHR.setRequestHeader('Authorization', token);
        },
        datatype: 'json',
        id: '',
        datafields: [
          { name: 'id', type: 'string' },
          { name: 'awb_id', type: 'string' },
          { name: 'awb_number', type: 'string' },
          { name: 'pick_status', type: 'string' },
          { name: 'pieces', type: 'string' },
          { name: 'rcf', type: 'string' },
          { name: 'man', type: 'string' },
          { name: 'msca', type: 'string' },
          { name: 'package', type: 'string' },
          { name: 'uld_number', type: 'string' },
          { name: 'weight', type: 'string' },
          { name: 'volume', type: 'string' },
          { name: 'lm', type: 'string' },
          { name: 'nature_of_goods', type: 'string' },
        ],
        filter: function (allfilters) {
          window.$(gridRef.current).jqxGrid('clearselection');
          setGridSelect([]);

          if (allfilters.length > 0) {
            console.log("Filter Applied");
            setFilterApplied(true);
          } else {
            console.log("Filter Cleared");
            setFilterApplied(false);
          }
          window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
        },
        sort: function () {
          window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
        // localdata: gridData,
      };

      const dataAdapter = new window.$.jqx.dataAdapter(source);
      const columns = [
        { text: 'Airway Bill', datafield: 'awb_number', width: '8%' },
        {
          text: 'Pickup Status', datafield: 'pick_status', width: '11%', filterable: false,
          cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
            if (value && Array.isArray(value)) {
              // Generate multiple divs for each item in the array
              const content = value
                .map((item) =>
                  `<div class="${item.color_status || ''}">${item.status || ''}</div>`
                ).join(''); // Combine all divs into a single string

              return `<div class="stats_view">${content}</div>`;
            }
            // Fallback if value is not an array or empty
            return defaulthtml;
          }
        },
        { text: 'Pcs', datafield: 'pieces', width: '7%' },
        { text: 'RCF', datafield: 'rcf', width: '7%' },
        { text: 'MAN', datafield: 'man', width: '7%' },
        { text: 'MSCA', datafield: 'msca', width: '7%' },
        { text: 'Package', datafield: 'package', width: '5%' },
        { text: 'ULD No.', datafield: 'uld_number', width: '15%' },
        { text: 'Weight', datafield: 'weight', width: '8%' },
        { text: 'Volume', datafield: 'volume', width: '8%' },
        { text: 'LM', datafield: 'lm', width: '8%' },
        { text: 'Nature of Goods', datafield: 'nature_of_goods', width: '8%' },
      ];



      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        height: 1040,
        columns: columns,
        autoheight: true,
        sortable: true,
        altrows: false,
        enabletooltips: true,
        editable: false,
        selectionmode: '', // checkbox
        pageable: true,
        pageSize: 50,
        pagesizeoptions: ['50', '100', '200', '500'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,

      };

      window.$(gridRef.current).jqxGrid(gridOptions);
      window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

      window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      window.$(gridRef.current).off('cellclick');
      window.$(gridRef.current).on('cellclick', (event) => {
        const args = event.args.row.bounddata;
        // console.log('event', args)
        if (event.args.columnindex > -1) {

          if (gridSelect) {
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
            // setGridSelect([]);
          }
          loadDetails(args.awb_id);
          // setSelectedRowData(args);
        }
      });

      // }
    }
  }, [gridData]);

  const loadDetails = async (id) => {
    setDisLoading(true);
    try {
      const res = await withRFSToken.post(TRUCKAWBDETAILS, { awb_id: id })
        .then(function (res) {
          const innerData = res.data.response_data;
          // console.log("🚀 ~ .then ~ innerData:654", innerData)
          setSelectedRowData(innerData);
          setDisLoading(false);
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleCloseClick = () => {
    setSelectedRowData(null);
    window.$(gridRef.current).jqxGrid("updatebounddata");
  };

  // FILE UPLOAD START
  const [showModalUpload, setShowModalUpload] = useState(false);
  const [showModalRequestSlot, setShowModalRequestSlot] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [base64Files, setBase64Files] = useState([]);
  const [messageText, setMessageText] = useState('');
  const [selectedSlot, setSelectedSlot] = useState({ type: '', index: null });

  // const imageModalUpload = (id) => {
  //     setSelectedRowId(id);
  //     setShowModalUpload(true)
  //     setFiles([])
  // }

  const imageModalUpload = (id) => {
    const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
    setFiles(selectedRowFiles);
    setSelectedRowId(id); // Store the ID of the selected row
    setShowModalUpload(true);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    getBase64(droppedFiles[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    base64Files.splice(index, 1);
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const filesWithBase64 = [];

    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        // filesWithBase64.push({ file, base64: reader.result });
        filesWithBase64.push({ "base64": reader.result, "file_name": file.name });
        if (filesWithBase64.length === selectedFiles.length) {
          // setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);
          // setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => obj.base64)]);
          setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
          setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
        }
      };
      reader.readAsDataURL(file);
    });
  };
  const imageUpload = () => {
    setGridSelect(prevGridSelect =>
      prevGridSelect.map(item => {
        if (item.uid === selectedRowId) {
          return { ...item, files: files, base64Files: base64Files };
        }
        return item;
      })
    );
    setShowModalUpload(false);
  };

  const movementHistoryClick = () => {
    localStorage.removeItem('MHistory');
    const storageData = {
      ULD: selectedRowData,  // ULD Details section
      Form: {}  // Empty form section
    };
    localStorage.setItem('MHistory', JSON.stringify(storageData));
    // localStorage.setItem('tab', 'operations');
    window.location.href = '/ULDControl/MovementHistory'
  };
  // upload forward
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };

  const OrderViewDetailsClick = (rData) => {

    try {
      // Check if selectedRowData is defined
      if (!selectedRowData) {
        throw new Error('Selected row data is not available.');
      }

      localStorage.removeItem('OVDetails');
      const storageData = {
        ULD: selectedRowData ?? rData,  // ULD Details section
        sec: 'AD',
        Form: {},  // Empty form section
        Back: { url: '/TruckMonitor', tab: 'awb' }
      };
      localStorage.setItem('OVDetails', JSON.stringify(storageData));
      // localStorage.setItem('tab', 'assets');
      // window.location.href = '/TruckMonitor/Details'
      detailsClick()
    } catch (error) {
      // Log the error for debugging purposes
      console.error('Error during navigation:', error.message);
      alert('An error occurred: ' + error.message); // Optional user alert
    }
  }
  const handleRequestSlot = () => {
    setShowModalRequestSlot(true);
  }
  const isMount = useRef(false);
  const [getDestination, setGetDestination] = useState([]);
  const [selectedHandler, setSelectedHandler] = useState(null);
  const [handlerNames, setHandlerNames] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [handlerDoorConfig, setHandlerDoorConfig] = useState();
  const [allAvailableSlotCount, setAllAvailableSlotCount] = useState([]);
  const [bookingSlotsPast, setBookingSlotsPast] = useState([]);
  const [bookingSlotsPresent, setBookingSlotsPresent] = useState([]);
  const [bookingSlotsFuture, setBookingSlotsFuture] = useState([]);
  const [warehouseId, setWarehouseId] = useState();
  const daysToShow = 4;
  const [dateList, setDateList] = useState([]);
  useEffect(() => {
    const dates = generateDateRange(currentDate, 4); // 7 days
    setDateList(dates);
    if (sbFormData.handler_id)
      availableSlotCount(dates);
  }, [currentDate, warehouseId]);
  const generateDateRange = (startDate, days) => {
    const dates = [];
    for (let i = 0; i < days; i++) {
      const newDate = new Date(startDate);
      newDate.setDate(startDate.getDate() + i);
      dates.push(newDate);
    }
    return dates;
  };
  const [tdFormData, setTdFormData] = useState({
    first_name: "",
    last_name: "",
    license_plate: "",
    side_loading: "No",
    vehicle_type: "Van",
  });

  const [odFormData, setOdFormData] = useState({
    orderId: "",
    weight: "",
    pieces: "",
  });

  const [sbFormData, setSbFormData] = useState({
    slotDate: "",
    slotTime: "",
  });
  const steps = [
    { id: 1, title: "Trip Details" },
    { id: 2, title: "Order Details" },
    { id: 3, title: "Slot Booking" }
  ];
  const [activeStep, setActiveStep] = useState(1);

  const goNext = () => {
    if (activeStep < steps.length) setActiveStep(activeStep + 1);
  };

  const goPrevious = () => {
    if (activeStep > 1) setActiveStep(activeStep - 1);
  };

  const handleChange = (form, event) => {
    const { name, value } = event.target;
    if (form === "td") {
      setTdFormData(prev => ({ ...prev, [name]: value }));
    }
    if (form === "od") {
      setOdFormData(prev => ({ ...prev, [name]: value }));
    }
    if (form === "sb") {
      setSbFormData(prev => ({ ...prev, [name]: value }));
    }
  };
  useEffect(() => {
    if (sbFormData.staion_name) {
      if (isMount.current) return;
      fetchHandler(sbFormData.staion_name);
      isMount.current = true;
    }
  }, [sbFormData.staion_name])
  useEffect(() => {
    console.log("sbFormData", sbFormData);
    console.log("tdFormData", tdFormData);
    console.log("odFormData", odFormData);
  }, [tdFormData, odFormData, sbFormData]);

  const fetchDestination = async () => {
    try {

      const res = await withRFSToken.post('uld-from/get-forwarder-origin', {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.value,
            label: item.label,
            handler_name: item.handler_name,
            portCodeName: item.portCodeName
          })) : [];
          setGetDestination(innerData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const fetchHandler = async (stationCode) => {
    try {
      const res = await withRFSToken.post('uld-from/get-forwarder-handler', { station_code: stationCode });
      const innerData = res.data.response_data;
      setHandlerNames(innerData);
    } catch (error) {
      console.error('Error fetching handler data:', error);
      return [];
    }
  }
  const formatTime = (datetime) => {
    return new Date(datetime).toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  };

  const formatDate = (datetime) => {
    return new Date(datetime).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short', // e.g., Sep
    });
  };

  function handleNext() {
    const newDate = new Date(currentDate);
    newDate.setDate(currentDate.getDate() + daysToShow);
    setCurrentDate(newDate);
    setSbFormData(prev => {
      const { booking_slot_date, ...rest } = prev;
      return rest;
    });
  }

  function handlePrevious() {
    const newDate = new Date(currentDate);
    newDate.setDate(currentDate.getDate() - daysToShow);
    setCurrentDate(newDate);
    setSbFormData(prev => {
      const { booking_slot_date, ...rest } = prev;
      return rest;
    });
  }
  function isSameDay(date1, date2) {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }
  function isCurrentDate(date) {
    const today = new Date();
    return date.toDateString() === today.toDateString();
  }
  const handleDayClick = (date) => {

    // Convert the date to the format "YYYY-MM-DD"
    const formattedDate = date.toISOString().split('T')[0];


    // Update the state with the fetched slots
    setSelectedDate(date);  // Store the selected date
    const updatedData = { ...sbFormData, booking_slot_time: "" };
    setSbFormData(updatedData);
    // Update formData with the selected date
    // setSbFormData(prev => ({
    //     ...prev,
    //     booking_slot_date: formattedDate  // Store in 'YYYY-MM-DD' format
    // }));
  };
  function getDayName(date) {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return days[date.getDay()];
  }
  const countAvailableSlots = (date) => {
    // const formattedDate = date.toISOString().split('T')[0];
    // const slotsForDate = apiData[formattedDate] || [];
    // // console.log("🚀 ~ countAvailableSlots ~ slotsForDate:", slotsForDate);
    // const availableSlotsCount = slotsForDate.filter(slot => slot.status === 1).length;
    let availableSlotsCount = 0;
    allAvailableSlotCount.forEach(element => {
      if (date == element.date) {
        availableSlotsCount = element.available_no_of_slot;
      }
    });
    return availableSlotsCount;
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name == "booking_slot_time") {
      availableSlot(value);
    }
  };
  const handleSlotClick = (type, index) => {
    // setSelectedSlotId(index);
    // setSbFormData({ ...formData, slot: showBookingSlots[index] });
    setSelectedSlot({ type, index });
    const slotList = type === 'past' ? bookingSlotsPast : bookingSlotsFuture;
    setSbFormData({ ...sbFormData, slot: slotList[index] });
  };
  const availableSlot = async (value) => {
    try {
      const dateVal = selectedDate.toISOString().split('T')[0];
      const timeVal = value;
      const res = await withRFSToken.post(SLOTPLANNINGAVAILABLESLOT, {
        "warehouse_id": sbFormData.warehouse_id,
        "date": dateVal,
        "time": timeVal,
        "cargo_type_id": 3,
        "trip_type_id": 8,
      });
      if (res.data.response_code == 200) {
        const { recentBefore, recentSlots, upcomingAfter } = res.data.response_data;
        setSelectedSlot({ type: '', index: null });
        setBookingSlotsPast(recentBefore);
        setBookingSlotsPresent(recentSlots);
        setBookingSlotsFuture(upcomingAfter);
        if (res.data.response_data.recentSlots.door_id) {
          setSbFormData(prev => ({
            ...prev,
            booking_slot_time: value,
            slot: [],
            ...(recentSlots?.door_id ? { slot: recentSlots } : {})
          }));
          setMessageText('');
        } else {
          setSbFormData(prev => ({
            ...prev,
            booking_slot_time: value,
          }));
          setMessageText('No timeslot is currently available at your selected time. Please choose from the closest available timeslots below.');
        }
      } else if (res.data.response_code == 400) {
        setMessageText(res.data.response_msg);
        setSbFormData(prev => ({
          ...prev,
          booking_slot_time: value,
        }));
      } else {
        toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error('Error fetching warehouse data:', error);
    }
  }
  const availableSlotCount = async (dates) => {
    const startDate = dates[0].toISOString().split('T')[0];
    const endDate = dates[dates.length - 1].toISOString().split('T')[0];
    try {
      const res = await withRFSToken.post(SLOTPLANNINGAVAILABLESLOTCOUNT, {
        "warehouse_id": sbFormData.warehouse_id,
        "start_date": startDate,
        "end_date": endDate,
        "cargo_type_id": 3,
        "trip_type_id": 8,
      });
      if (res.data.response_code == 200) {
        setAllAvailableSlotCount(res.data.response_data);
      } else {
        // toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error('Error fetching warehouse data:', error);
    }
  }
  return (
    <>

      <div className="main-content">
        {disLoading &&
          <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
        }
        <div className='maindiv'>
          <div className='trashdonload'>
            {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>}
          </div>
          {selectedRowData && (
            <div className='SecondDiv'>
              <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
              <div className='girddtals_header'>
                <h3>
                  {selectedRowData.awb_no} &nbsp;
                  <span className='position-relative'>
                    {
                      selectedRowData?.pick_status && Array.isArray(selectedRowData?.pick_status) ?
                        selectedRowData?.pick_status.map((item) =>
                          <>
                            {/* <div class=""> */}
                            <div class={`mt-0 ${item.color_status}`} style={{ position: 'absolute', top: '1px', left: '0' }}>{item.status || ''}</div>
                            {/* </div> */}
                          </>
                        )
                        : ''
                    }
                  </span>
                </h3>
                <div className='d-flex actbtn justify-content-between'>

                  <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                  <div className='viwall'>
                    <Link to='#' onClick={() => OrderViewDetailsClick(selectedRowData)} >View Details</Link>
                  </div>
                  {/* <Dropdown>
                                      <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                          <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                      </Dropdown.Toggle>
  
                                      <Dropdown.Menu>
                                          <Dropdown.Item >option</Dropdown.Item>
                                          <Dropdown.Item >option</Dropdown.Item>
                                          <Dropdown.Item >option</Dropdown.Item>
                                      </Dropdown.Menu>
                                  </Dropdown> */}

                </div>

              </div>
              <div className='d-flex justify-content-between my-3'>
                <div className='order_view'>
                  <h3>{selectedRowData.loading_station}</h3>
                  {/* <span>{selectedRowData.loading_name}</span> */}
                  <span>
                    {selectedRowData.loading_name && selectedRowData.loading_name.length > 20
                      ? `${selectedRowData.loading_name.slice(0, 20)}...`
                      : selectedRowData.loading_name}
                  </span>
                  <div className='mt-3'>
                    <p>Scheduled - <b>{selectedRowData.loading_date_scheduled} <span></span></b> {/*CEST*/}</p>
                    <p>Actual - <b>{selectedRowData.loading_date_actual} <span></span></b> {/*CEST*/}</p>
                  </div>
                </div>
                <div className='order_middle'>
                  <p><img src={Cargotruck} /></p>
                  <span>{selectedRowData.truck_number}</span>
                </div>
                <div className='order_view'>
                  <h3>{selectedRowData.unloading_station}</h3>
                  {/* <span>{selectedRowData.unloading_name}</span> */}
                  <span>
                    {selectedRowData.unloading_name && selectedRowData.unloading_name.length > 20
                      ? `${selectedRowData.unloading_name.slice(0, 20)}...`
                      : selectedRowData.unloading_name}
                  </span>
                  <div className='mt-3'>
                    <p>Scheduled - <b>{selectedRowData.unloading_date_scheduled} <span></span></b> {/*CEST*/}</p>
                    <p>ETA - <b>{selectedRowData.unloading_date_actual} <span></span></b> {/*CEST*/}</p>
                  </div>
                </div>
              </div>
              <div className='mb-3'>
                <ProgressBar animated now={50} style={{ height: "5px" }} />
              </div>
              <div className='movment_history'>
                <h3>Status Updates</h3> {/*<Link to='#' onClick={movementHistoryClick}>View All</Link>*/}
              </div>
              <div className='movment_list'>
                <ul>
                  {selectedRowData && selectedRowData?.status_updates.map((history, index) => (
                    <li>
                      <span className='movem w-auto'>{history.status}</span>
                      <span className='mvdate'>{history.date}&nbsp;&nbsp;&nbsp;&nbsp;{history.time}</span>
                      {/* <Link to='#' >Details</Link> onClick={() => handleDetailsClick(history)} */}
                    </li>
                  ))}
                </ul>
              </div>
              <ImageUpload
                ref={imageUploadRef}
                attachable_type={"rfs_awb"}
                attachable_id={selectedRowData.awb_id}
                attachments={selectedRowData.attachments}
                onDeleteSuccess={() => loadDetails(selectedRowData.awb_id)}
              />
              <ActivityComments
                commentable_type={"rfs_awb"}
                commentable_id={selectedRowData.awb_id}
                allactivities={selectedRowData.activities}
                onReloadDetails={() => loadDetails(selectedRowData.awb_id)}
              />
            </div>
          )}
        </div>
      </div>
      <Modal show={showModalRequestSlot} onHide={() => setShowModalRequestSlot(false)} className='addfrom change_type' centered size={'xl'}>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <div className="stepper-wrapper">
            <div className="stepper-left">
              <h4 className="stepper-title">CREATE TRIP</h4>
              <div className="stepper-menu">
                {steps.map((step, index) => {
                  const isActive = step.id === activeStep;
                  const isCompleted = step.id < activeStep;
                  return (
                    <div key={step.id} className={`stepper-item ${isActive ? "active" : ""}`} onClick={() => setActiveStep(step.id)}>
                      <div className={`step-number ${isCompleted ? "completed" : isActive ? "active-number" : ""}`}>
                        {isCompleted ? "✓" : step.id}
                      </div>
                      <div className="step-text">{step.title}</div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="stepper-content">
              <h2>{steps.find((s) => s.id === activeStep)?.title}</h2>
              <div className="step-content-box">
                {activeStep === 1 &&
                  <div>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-2">
                          <Form.Label>First Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="first_name"
                            value={tdFormData.first_name}
                            onChange={(e) => handleChange("td", e)}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2">
                          <Form.Label>Last Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="last_name"
                            value={tdFormData.last_name}
                            onChange={(e) => handleChange("td", e)}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2">
                          <Form.Label>License Plate</Form.Label>
                          <Form.Control
                            type="text"
                            name="license_plate"
                            value={tdFormData.license_plate}
                            onChange={(e) => handleChange("td", e)}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2">
                          <Form.Label>Vehicle Type</Form.Label>
                          <div className='d-flex'>
                            <Form.Check
                              type="radio"
                              id="vehicle-truck"
                              label="Truck"
                              name="vehicle_type"
                              value="Truck"
                              checked={tdFormData.vehicle_type === "Truck"}
                              onChange={() =>
                                handleChange("td", { target: { name: "vehicle_type", value: "Truck" } })
                              }
                            />

                            <Form.Check
                              type="radio"
                              id="vehicle-van"
                              label="Van"
                              name="vehicle_type"
                              value="Van"
                              checked={tdFormData.vehicle_type === "Van"}
                              onChange={() =>
                                handleChange("td", { target: { name: "vehicle_type", value: "Van" } })
                              }
                            />
                          </div>

                          {/* <div className="d-flex gap-2">
                                                          <Button
                                                              variant={tdFormData.vehicle_type === "Truck" ? "primary" : "outline-secondary"}
                                                              onClick={() =>
                                                                  handleChange("td", { target: { name: "vehicle_type", value: "Truck" } })
                                                              }
                                                          >
                                                              Truck
                                                          </Button>
                                                          <Button
                                                              variant={tdFormData.vehicle_type === "Van" ? "primary" : "outline-secondary"}
                                                              onClick={() =>
                                                                  handleChange("td", { target: { name: "vehicle_type", value: "Van" } })
                                                              }
                                                          >
                                                              Van
                                                          </Button>
                                                      </div> */}
                        </Form.Group>
                        <Form.Group className="mb-2">
                          <Form.Label>Side Loading</Form.Label>
                          <div className="d-flex gap-2">
                            {/* <Button
                                                              variant={tdFormData.side_loading === "Yes" ? "primary" : "outline-secondary"}
                                                              onClick={() =>
                                                                  handleChange("td", { target: { name: "side_loading", value: "Yes" } })
                                                              }
                                                          >
                                                              Yes
                                                          </Button>
                                                          <Button
                                                              variant={tdFormData.side_loading === "No" ? "primary" : "outline-secondary"}
                                                              onClick={() =>
                                                                  handleChange("td", { target: { name: "side_loading", value: "No" } })
                                                              }
                                                          >
                                                              No
                                                          </Button> */}
                            <Form.Check
                              type="radio"
                              id="side-loading-yes"
                              label="Yes"
                              name="side_loading"
                              value="Yes"
                              checked={tdFormData.side_loading === "Yes"}
                              onChange={() =>
                                handleChange("td", { target: { name: "side_loading", value: "Yes" } })
                              }
                            />

                            <Form.Check
                              type="radio"
                              id="side-loading-no"
                              label="No"
                              name="side_loading"
                              value="No"
                              checked={tdFormData.side_loading === "No"}
                              onChange={() =>
                                handleChange("td", { target: { name: "side_loading", value: "No" } })
                              }
                            />
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                }
                {activeStep === 2 &&
                  <div>
                    <Row className='align-items-center'>
                      <Col md={4}>
                        <Button variant="primary" className="mb-3">
                          Add Trip
                        </Button>
                      </Col>
                      <Col md={4}>
                        <Form.Group className="mb-2">
                          <Form.Control
                            type="text"
                            name="first_name"
                            value={tdFormData.first_name}
                            onChange={(e) => handleChange("td", e)}
                            placeholder='Truck No'
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group className="mb-2">
                          <Form.Control
                            type="date"
                            name="last_name"
                            value={tdFormData.last_name}
                            onChange={(e) => handleChange("td", e)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} className='order_details_truck'>
                        <Row className="align-items-base-line truck-row">

                          {/* Truck Number */}
                          <Col md={4}>
                            <Form.Label>Truck Number *</Form.Label>

                            <Form.Group className="truck-number-group">
                              <Form.Select className="prefix-select">
                                <option>Prefix</option>
                              </Form.Select>
                              <Form.Control placeholder="2044" />
                            </Form.Group>
                          </Col>

                          {/* Truck Date */}
                          <Col md={4}>
                            <Form.Label>Truck Date *</Form.Label>

                            <Form.Group>
                              <Form.Control placeholder="dd-mm-yyyy" />

                              {/* <Form.Group.Text className="calendar-box">
                                                                  <i className="bi bi-calendar-date"></i>
                                                              </Form.Group.Text> */}
                            </Form.Group>
                          </Col>

                          {/* AMS - BRU */}
                          <Col md={4} className="text-center">
                            <Button variant="outline-primary" className="route-btn">
                              AMS - BRU
                            </Button>
                          </Col>
                        </Row>

                        {/* Row 2 */}
                        <Row className="mt-3">
                          <Col md={2}>
                            <Form.Label>ULD No.</Form.Label>
                            <Form.Control placeholder="PMC37742EK" />
                          </Col>

                          <Col md={2}>
                            <Form.Label>Pieces *</Form.Label>
                            <Form.Control placeholder="19" />
                          </Col>

                          <Col md={2}>
                            <Form.Label>Weight</Form.Label>
                            <Form.Control placeholder="114" />
                          </Col>

                          <Col md={2}>
                            <Form.Label>Volume</Form.Label>
                            <Form.Control placeholder="0.208" />
                          </Col>

                          <Col md={4}>
                            <Form.Label>SHC</Form.Label>

                            <Form.Group className='truck-number-group'>
                              <Form.Control placeholder="COL, CRT" />
                              <Form.Select>
                                <option></option>
                                <option>CC</option>
                                <option>CT</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                        </Row>

                      </Col>
                    </Row>
                  </div>
                }
                {activeStep === 3 &&
                  <div>
                    <Row>
                      <Col sm='6'>
                        <div className='loading_dv'>
                          <h2>Loading Station</h2>
                          <div className="rounded charter_top charter_from">
                            <Form.Group as={Row} className="mb-3" controlId="acn">
                              <Col sm="6">
                                <label className="form-label" >Station Code <span>*</span></label>
                                <Select
                                  options={getDestination}
                                  onChange={(selected) => {
                                    const selectedDestination = getDestination.find(option => option.value === selected.value);
                                    setSbFormData(prev => ({
                                      ...prev,
                                      staion_name: selected.value,
                                      staion_id: selected.port_Id,
                                    }));
                                    setSelectedHandler(null);
                                  }}
                                  placeholder="Station"
                                  className="autoslct w-100"
                                  name="staion_name"
                                  value={getDestination.find(option => option.value === sbFormData.staion_id)}
                                />
                              </Col>
                              <Col sm="6">
                                <label className="form-label">Handler Name <span>*</span></label>
                                <Select
                                  options={handlerNames}
                                  onChange={(selected) => {
                                    setSbFormData(prev => ({
                                      ...prev,
                                      handler_name: selected.label,
                                      handler_id: selected.value,
                                    }));
                                  }
                                  }
                                  placeholder="Handler Name"
                                  className="autoslct me-0 w-100"
                                  name="handler_id"
                                  value={handlerNames.find(option => option.value === sbFormData.handler_id)}
                                />
                              </Col>
                            </Form.Group>
                          </div>
                          <div className="rounded charter_top h-90 px-1 bookig_slot" >
                            <h4>Booking Slot</h4>
                            <div className="calendar-container">
                              <div className="d-flex justify-content-between align-items-center">
                                <div className='recent_time'>
                                  <h6>{new Date(selectedDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })}</h6>
                                </div>
                                <div>
                                  <button className='btnleft' onClick={handlePrevious}> <FontAwesomeIcon icon={faChevronLeft} /> </button>
                                  <button className='btnright' onClick={handleNext}> <FontAwesomeIcon icon={faChevronRight} /> </button>

                                </div>
                              </div>
                              <div className="scrollable-calendar mb-4 mt-3">
                                {dateList.map((date, index) => (
                                  <div
                                    key={index}
                                    className={`day ${isCurrentDate(date) ? 'current-date' : ''} ${selectedDate && isSameDay(date, selectedDate) ? 'active' : ''}`}
                                    onClick={() => handleDayClick(date)}
                                  >
                                    <div className="day-name">{getDayName(date)}</div>
                                    <div className="date">{date.getDate()}</div>
                                    <div className='slot'> <span></span> {countAvailableSlots(date.toISOString().split('T')[0])} slots </div>
                                  </div>
                                ))}
                              </div>
                              <div className='mb-3'>
                                <div className='planed_time'>
                                  <label>Planned Time</label>
                                  <Form.Group>
                                    <input
                                      type="time" name="booking_slot_time" id='datetime' className='form-control'
                                      value={sbFormData.booking_slot_time} dateFormat="yyyy-MM-dd" onChange={handleInputChange}
                                    />
                                  </Form.Group>
                                </div>
                                <div className='notavail_door'>
                                  <p className='text-danger'>
                                    {messageText}
                                  </p>
                                </div>
                                {bookingSlotsPresent?.door_id && (
                                  <div className='avail_door'>
                                    <p>Available - {bookingSlotsPresent.door_no}</p>
                                    <span>
                                      Timeslot - {formatTime(bookingSlotsPresent.start_time)} to {formatTime(bookingSlotsPresent.end_time)}
                                    </span>
                                  </div>
                                )}
                              </div>
                              {bookingSlotsPast.length > 0 && (
                                <div className='avalable'>
                                  <h2>Earlier Timeslot</h2>
                                  <div className="timeslot">
                                    {bookingSlotsPast.map((slot, index) => (
                                      <div
                                        key={`past-${index}`}
                                        className={`available time ${selectedSlot.type === 'past' && selectedSlot.index === index ? 'selected' : ''}`}
                                        onClick={() => handleSlotClick('past', index)}
                                      >
                                        <h4>{slot.door_no}</h4>
                                        {new Date(slot.start_time).toDateString() !== new Date(slot.end_time).toDateString() ? (
                                          <>
                                            <p>{formatDate(slot.start_time)} - {formatDate(slot.end_time)}</p>
                                            <p>{formatTime(slot.start_time)} - {formatTime(slot.end_time)}</p>
                                          </>
                                        ) : (
                                          <>
                                            <p>{formatDate(slot.start_time)}</p>
                                            <p>{formatTime(slot.start_time)} - {formatTime(slot.end_time)}</p>
                                          </>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                              {bookingSlotsFuture.length > 0 && (
                                <div className='avalable'>
                                  <h2>Later Timeslot</h2>
                                  <div className="timeslot">
                                    {bookingSlotsFuture.map((slot, index) => (
                                      <div
                                        key={`future-${index}`}
                                        className={`available time ${selectedSlot.type === 'future' && selectedSlot.index === index ? 'selected' : ''}`}
                                        onClick={() => handleSlotClick('future', index)}
                                      >
                                        <h4>{slot.door_no}</h4>
                                        {new Date(slot.start_time).toDateString() !== new Date(slot.end_time).toDateString() ? (
                                          <>
                                            <p>{formatDate(slot.start_time)} - {formatDate(slot.end_time)}</p>
                                            <p>{formatTime(slot.start_time)} - {formatTime(slot.end_time)}</p>
                                          </>
                                        ) : (
                                          <>
                                            <p>{formatDate(slot.start_time)}</p>
                                            <p>{formatTime(slot.start_time)} - {formatTime(slot.end_time)}</p>
                                          </>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                      </Col>
                      <Col sm='6'>
                        <div className='unloading_dv'>
                          <h2>Unloading Station</h2>
                          <div className="rounded charter_top charter_from">
                            <Form.Group as={Row} className="mb-3" controlId="acn">
                              <Col sm="6">
                                <label className="form-label" >Station Code <span>*</span></label>
                                <Select
                                  options={getDestination}
                                  onChange={(selected) => {
                                    const selectedDestination = getDestination.find(option => option.value === selected.value);
                                    setSbFormData(prev => ({
                                      ...prev,
                                      staion_name: selected.value,
                                      staion_id: selected.port_Id,
                                    }));
                                    setSelectedHandler(null);
                                  }}
                                  placeholder="Station"
                                  className="autoslct w-100"
                                  name="staion_name"
                                  value={getDestination.find(option => option.value === sbFormData.staion_id)}
                                />
                              </Col>
                              <Col sm="6">
                                <label className="form-label">Handler Name <span>*</span></label>
                                <Select
                                  options={handlerNames}
                                  onChange={(selected) => {
                                    setSbFormData(prev => ({
                                      ...prev,
                                      handler_name: selected.label,
                                      handler_id: selected.value,
                                    }));
                                  }
                                  }
                                  placeholder="Handler Name"
                                  className="autoslct me-0 w-100"
                                  name="handler_id"
                                  value={handlerNames.find(option => option.value === sbFormData.handler_id)}
                                />
                              </Col>
                            </Form.Group>
                          </div>
                          <div className="rounded charter_top h-90 px-1 bookig_slot" >
                            <h4>Booking Slot</h4>
                            <div className="calendar-container">
                              <div className="d-flex justify-content-between align-items-center">
                                <div className='recent_time'>
                                  <h6>{new Date(selectedDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })}</h6>
                                </div>
                                <div>
                                  <button className='btnleft' onClick={handlePrevious}> <FontAwesomeIcon icon={faChevronLeft} /> </button>
                                  <button className='btnright' onClick={handleNext}> <FontAwesomeIcon icon={faChevronRight} /> </button>

                                </div>
                              </div>
                              <div className="scrollable-calendar mb-4 mt-3">
                                {dateList.map((date, index) => (
                                  <div
                                    key={index}
                                    className={`day ${isCurrentDate(date) ? 'current-date' : ''} ${selectedDate && isSameDay(date, selectedDate) ? 'active' : ''}`}
                                    onClick={() => handleDayClick(date)}
                                  >
                                    <div className="day-name">{getDayName(date)}</div>
                                    <div className="date">{date.getDate()}</div>
                                    <div className='slot'> <span></span> {countAvailableSlots(date.toISOString().split('T')[0])} slots </div>
                                  </div>
                                ))}
                              </div>
                              <div className='mb-3'>
                                <div className='planed_time'>
                                  <label>Planned Time</label>
                                  <Form.Group>
                                    <input
                                      type="time" name="booking_slot_time" id='datetime' className='form-control'
                                      value={sbFormData.booking_slot_time} dateFormat="yyyy-MM-dd" onChange={handleInputChange}
                                    />
                                  </Form.Group>
                                </div>
                                <div className='notavail_door'>
                                  <p className='text-danger'>
                                    {messageText}
                                  </p>
                                </div>
                                {bookingSlotsPresent?.door_id && (
                                  <div className='avail_door'>
                                    <p>Available - {bookingSlotsPresent.door_no}</p>
                                    <span>
                                      Timeslot - {formatTime(bookingSlotsPresent.start_time)} to {formatTime(bookingSlotsPresent.end_time)}
                                    </span>
                                  </div>
                                )}
                              </div>
                              {bookingSlotsPast.length > 0 && (
                                <div className='avalable'>
                                  <h2>Earlier Timeslot</h2>
                                  <div className="timeslot">
                                    {bookingSlotsPast.map((slot, index) => (
                                      <div
                                        key={`past-${index}`}
                                        className={`available time ${selectedSlot.type === 'past' && selectedSlot.index === index ? 'selected' : ''}`}
                                        onClick={() => handleSlotClick('past', index)}
                                      >
                                        <h4>{slot.door_no}</h4>
                                        {new Date(slot.start_time).toDateString() !== new Date(slot.end_time).toDateString() ? (
                                          <>
                                            <p>{formatDate(slot.start_time)} - {formatDate(slot.end_time)}</p>
                                            <p>{formatTime(slot.start_time)} - {formatTime(slot.end_time)}</p>
                                          </>
                                        ) : (
                                          <>
                                            <p>{formatDate(slot.start_time)}</p>
                                            <p>{formatTime(slot.start_time)} - {formatTime(slot.end_time)}</p>
                                          </>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                              {bookingSlotsFuture.length > 0 && (
                                <div className='avalable'>
                                  <h2>Later Timeslot</h2>
                                  <div className="timeslot">
                                    {bookingSlotsFuture.map((slot, index) => (
                                      <div
                                        key={`future-${index}`}
                                        className={`available time ${selectedSlot.type === 'future' && selectedSlot.index === index ? 'selected' : ''}`}
                                        onClick={() => handleSlotClick('future', index)}
                                      >
                                        <h4>{slot.door_no}</h4>
                                        {new Date(slot.start_time).toDateString() !== new Date(slot.end_time).toDateString() ? (
                                          <>
                                            <p>{formatDate(slot.start_time)} - {formatDate(slot.end_time)}</p>
                                            <p>{formatTime(slot.start_time)} - {formatTime(slot.end_time)}</p>
                                          </>
                                        ) : (
                                          <>
                                            <p>{formatDate(slot.start_time)}</p>
                                            <p>{formatTime(slot.start_time)} - {formatTime(slot.end_time)}</p>
                                          </>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                      </Col>
                    </Row>
                  </div>
                }
              </div>
              <div className="stepper-buttons are_bottom ">
                <button className="btn-prev" disabled={activeStep === 1} onClick={goPrevious}>
                  Previous
                </button>

                <button className="btn-next" disabled={activeStep === steps.length} onClick={goNext}>
                  Next
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  )
}

export default Awbs